// //////////////////////////////////////////////////////////
// This helper is already imported in our common bundle !
// //////////////////////////////////////////////////////////

if (typeof Element.prototype.offset !== 'function') {
    Element.prototype.offset = function offset() {
        const rect = this.getBoundingClientRect();
        return {
            top: rect.top + document.body.scrollTop,
            left: rect.left + document.body.scrollLeft,
        };
    };
}
